import React from 'react'
import PropTypes from 'prop-types'

import {
  DialogButtonGroup,
  Callout,
} from '~/components/blueprint'

class EditDialog extends React.Component {
  constructor(props){
    super(props)
    this.handleSave = this.handleSave.bind(this)
    this.handleChange = this.handleChange.bind(this)
    let model = JSON.parse(JSON.stringify(props.model))
    this.state = {
      model,
      error: null,
    }
  }
  handleSave(){
    let { model } = this.state
    this.props.onSave(model)
  }
  handleChange({target}){
    let { name, value } = target
    this.setState((state)=>{
      // if (['type', 'reset', 'base'].includes(name)){
      if (['type', 'reset', 'base'].indexOf(name) >= 0){
        value = parseInt(value)
      }
      state.model[name] = value
      return state
    })
  }
  render(){
    let { onCancel, types, bases, resets } = this.props
    let { model, error } = this.state
    return (
      <div className="bp-dialog">
        <div className="line">Name</div>
        <div className="line">
          <input className="pt-input pt-fill" name="name" value={model.name} onChange={this.handleChange}/>
        </div>
        <div className="justify">
          <div>
            <div className="line">Type</div>
            <div className="line pt-select pt-fill">
              <select name="type" value={model.type} onChange={this.handleChange}>
                {types.map(({id, name})=><option key={id} value={id}>{name}</option>)}
              </select>
            </div>
          </div>
          <div>
            <div className="line">Reset</div>
            <div className="line pt-select pt-fill">
              <select name="reset" value={model.reset} onChange={this.handleChange}>
                {resets.map(({id, name})=><option key={id} value={id}>{name}</option>)}
              </select>
            </div>
          </div>
        </div>
        <div className="justify">
          <div>
            <div className="line">Base</div>
            <div className="line pt-select pt-fill">
              <select name="base" value={model.base} onChange={this.handleChange}>
                {bases.map(({id, name})=><option key={id} value={id}>{name}</option>)}
              </select>
            </div>
          </div>
          <div>
            <div className="line">Format (# will be replaced by natural number)</div>
            <div className="line">
              <input className="pt-input pt-fill" placeholder="e.g. AB#####" name="format" value={model.format} onChange={this.handleChange}/>
            </div>
          </div>
        </div>
        {error?<Callout error={error}/>:null}
        <DialogButtonGroup onSave={this.handleSave} onCancel={onCancel} />
      </div>
    )
  }
}

EditDialog.propTypes = {
  model: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  types: PropTypes.array,
  resets: PropTypes.array,
  bases: PropTypes.array,
}

export default EditDialog



/** WEBPACK FOOTER **
 ** ./client/pages/settings/reference-number/EditDialog.js
 **/